<style>
a:hover {
  background-color: transparent !important;
}

.v-list-item--density-default.v-list-item--one-line {
  min-height: 60px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-bottom: 0.5px solid #ddd;
}
</style>
<template>
  <v-app>
    <v-app-bar color="#a61a2f" class="flex-grow-0" app dark>
      <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer">
      </v-app-bar-nav-icon>

      <img src="./assets/blancoc.svg" width="100" height="50" />

      <div style="margin-left: 2rem">
        <h3>{{ $store.state.titulo }}</h3>
      </div>

      <v-app-bar-title></v-app-bar-title>

      <v-spacer></v-spacer>

      <label style="margin-right: 20px"> {{ $store.state.nombre }} </label>
      <div v-if="!$store.state.isLogged">
        <v-btn variant="text" icon="mdi-login" v-on:click="login()"></v-btn>
      </div>
    </v-app-bar>

    <v-navigation-drawer app v-model="drawer" color="#646363">
      <v-list>
        <!-- Sección de Operaciones -->
        <v-list-subheader
          class="text-white font-weight-bold mb-2"
          style="font-size: 14px; letter-spacing: 0.5px"
        >
          OPERACIONES
        </v-list-subheader>

        <v-list-item>
          <template v-slot:prepend>
            <v-icon color="white" size="20">mdi-plus-circle</v-icon>
          </template>
          <router-link
            to="/SolCompra"
            class="menu"
            style="color: white; font-size: 16px"
            >Crear Solicitud</router-link
          >
        </v-list-item>

        <v-list-item>
          <template v-slot:prepend>
            <v-icon color="white" size="20">mdi-magnify</v-icon>
          </template>
          <router-link
            to="/BuscaSolicitud"
            class="menu"
            style="color: white; font-size: 16px"
            >Buscar Solicitud</router-link
          >
        </v-list-item>

        <!-- Sección de Mantenedores (solo para admin) -->
        <template v-if="esAdmin">
          <!-- Separación mayor entre secciones -->
          <div class="my-6">
            <!-- <v-divider color="white" opacity="0.5" thickness="2"></v-divider> -->
          </div>

          <v-list-subheader
            class="text-white font-weight-bold mb-2"
            style="font-size: 14px; letter-spacing: 0.5px"
          >
            MANTENEDORES
          </v-list-subheader>

          <v-list-item>
            <template v-slot:prepend>
              <v-icon color="white" size="20">mdi-shield-account</v-icon>
            </template>
            <router-link
              to="/RolMantenedor"
              class="menu"
              style="color: white; font-size: 16px"
              >Roles</router-link
            >
          </v-list-item>

          <v-list-item>
            <template v-slot:prepend>
              <v-icon color="white" size="20">mdi-office-building</v-icon>
            </template>
            <router-link
              to="/DeptoRolMantenedor"
              class="menu"
              style="color: white; font-size: 16px"
              >Departamento/Rol</router-link
            >
          </v-list-item>

          <v-list-item>
            <template v-slot:prepend>
              <v-icon color="white" size="20">mdi-account-group</v-icon>
            </template>
            <router-link
              to="/EmpleadoMantenedor"
              class="menu"
              style="color: white; font-size: 16px"
              >Empleados</router-link
            >
          </v-list-item>

          <v-list-item>
            <template v-slot:prepend>
              <v-icon color="white" size="20">mdi-account-cog</v-icon>
            </template>
            <router-link
              to="/UsuarioMantenedor"
              class="menu"
              style="color: white; font-size: 16px"
              >Usuarios</router-link
            >
          </v-list-item>

          <v-list-item>
            <template v-slot:prepend>
              <v-icon color="white" size="20">mdi-format-list-checks</v-icon>
            </template>
            <router-link
              to="/PermisosUsuario"
              class="menu"
              style="color: white; font-size: 16px"
              >Permisos de Usuario</router-link
            >
          </v-list-item>
        </template>
      </v-list>

      <template v-slot:append>
        <div class="pa-2" v-if="$store.state.isLogged">
          <v-btn
            v-if="esAdmin"
            v-on:click="sync()"
            style="
              display: contents !important;
              background-color: #098c3b;
              padding: 15px;
              border-radius: 15px;
              color: white;
              margin-left: auto;
              margin-right: auto;
              display: flex;
            "
          >
            Sincronizar Datos
          </v-btn>

          <v-btn
            v-if="esAdmin"
            v-on:click="syncEmpleadosBuk()"
            style="
              display: contents !important;
              background-color: #098c3b;
              padding: 15px;
              border-radius: 15px;
              color: white;
              margin-left: auto;
              margin-right: auto;
              display: flex;
              margin-top: 15px;
            "
          >
            Sincronizar Empleados BUK
          </v-btn>

          <v-btn
            v-on:click="logout()"
            style="
              background-color: #2b2b2b;
              padding: 15px;
              border-radius: 15px;
              color: white;
              margin-top: 15px;
              margin-left: auto;
              margin-right: auto;
              display: flex;
            "
          >
            Cerrar sesion
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main fluid>
      <router-view></router-view>
    </v-main>
  </v-app>

  <!-- <loading v-model:active="isLoading" :is-full-page="fullPage" /> -->
</template>

<script setup lang="ts">
import { ref } from "vue";
import { PublicClientApplication } from "@azure/msal-browser";
import { onMounted } from "vue";
import AzureService from "./services/AzureService";
import { useStore } from "vuex";
import { key } from "@/store";
import Emmitter from "tiny-emitter";
import { useCookies } from "vue3-cookies";
import { useRouter, useRoute } from "vue-router";
import type { Rol } from "./types/rol";
import axios from "axios";
import swal from "sweetalert2";
import useSincro from "./composables/useSincro";
import useUsuario from "./composables/useUsuario";

const { cookies } = useCookies();
const store = useStore(key);
const router = useRouter();
const route = useRoute();

const { sincronizarDatos, sincronizarEmpleadosBuk } = useSincro();
const { existeUsuarioEmail } = useUsuario();

const drawer = ref<boolean>(false);
// const isAuthenticated = ref<boolean>(false);
const esAdmin = ref<boolean>(false);
// let isLoading: boolean = false;
const roles = ref<Rol[]>([]);

let $msalInstance: PublicClientApplication;
const $emitter = new Emmitter.TinyEmitter();

onMounted(async () => {
  await cargarRoles();

  const azureService = new AzureService();
  $msalInstance = new PublicClientApplication(
    azureService.getMsalConfig().value
  );

  await $msalInstance.initialize();
  await $msalInstance.handleRedirectPromise();
  $msalInstance.acquireTokenSilent({
    scopes: ["user.read", "mail.send"],
  });

  if (cookies.isKey("isLogged")) {
    store.state.isLogged = cookies.get("isLogged") === "true";
  }

  if (cookies.isKey("account")) {
    store.state.account = cookies.get("account");
    store.state.nombre = store.state.account.name; //this.account.name;
  }
});

async function cargarRoles() {
  const username = cookies.get("username");

  if (!username) {
    roles.value = [];
    esAdmin.value = false;
    return;
  }

  roles.value = (await getRol(username)) ?? [];
  esAdmin.value = roles.value.some((r) => r.rolNombre === "Administrador");
}

async function login() {
  await $msalInstance
    .loginPopup()
    .then(async (response) => {
      const myAcccounts = $msalInstance.getAllAccounts();

      // console.log(myAcccounts[0]);

      $emitter.emit("login", myAcccounts[0]);

      // cookies.set("isLogged", "true");
      cookies.set("token", response.accessToken);
      //console.log("token: " + response.accessToken);
      cookies.set("account", store.state.account);
      cookies.set(
        "username",
        store.state.account.username ?? store.state.account.preferred_username
      );

      store.state.isLogged = true;
      store.state.nombre = myAcccounts[0].name;

      await cargarRoles();

      localStorage.removeItem("empresaSel");
      localStorage.removeItem("departamento");
      localStorage.removeItem("solId");
      localStorage.removeItem("ingresado");
      localStorage.removeItem("solicitante");
      localStorage.removeItem("tipoSol");
      localStorage.removeItem("bodega");
      localStorage.removeItem("bc365");
      localStorage.removeItem("fecha");
      localStorage.removeItem("estadoSel");
      localStorage.removeItem("comprador");
      localStorage.removeItem("proyecto");

      var existe = await existeUsuarioEmail(myAcccounts[0].username ?? "");

      if (existe) {
        router.push({ name: "BuscaSolicitud" });
      } else {
        swal.fire({
          icon: "warning",
          title: "Acceso Denegado",
          text: "Usuario no autorizado para acceder al sistema",
          showConfirmButton: false,
          timer: 2000,
        });

        //esperar 2 segundos para que el usuario vea el mensaje
        setTimeout(async () => {
          await logout();
        }, 2000);
      }
    })
    .catch((error: string) => {
      console.log(error);
    });
}

async function logout() {
  store.state.nombre = "Invitado";
  store.state.isLogged = false;
  store.state.email = "";

  cookies.remove("isLogged");
  cookies.remove("token");
  cookies.remove("account");
  cookies.remove("username");

  roles.value = [];
  esAdmin.value = false;

  localStorage.removeItem("empresaSel");
  localStorage.removeItem("departamento");
  localStorage.removeItem("solId");
  localStorage.removeItem("ingresado");
  localStorage.removeItem("solicitante");
  localStorage.removeItem("tipoSol");
  localStorage.removeItem("bodega");
  localStorage.removeItem("bc365");
  localStorage.removeItem("fecha");
  localStorage.removeItem("estadoSel");
  localStorage.removeItem("comprador");

  await $msalInstance.logout();
  $emitter.emit("logout");
}

async function getRol(email: string) {
  try {
    let tiene: Rol[] = [];

    // isLoading = true;

    await axios
      .get(store.state.url + "api/Rol/GetRol?email=" + email, {
        headers: {},
      })
      .then((response) => {
        if (response.status == 200) {
          tiene = response.data;
        } else {
          tiene = [];
        }
      })
      .catch(function (error) {
        console.log(error.message);
        tiene = [];
      });

    return tiene;
  } catch (error) {
    console.log(error);
  } finally {
    // isLoading = false;
  }
}

async function sync() {
  //show a swal asking if the user wants to sync data
  const swal = await import("sweetalert2");
  const result = await swal.default.fire({
    title: "Sincronizar Datos",
    text: "¿Está seguro de que desea sincronizar los datos?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, sincronizar",
    cancelButtonText: "Cancelar",
  });

  if (result.isConfirmed) {
    await sincronizarDatos();
  } else {
    console.log(
      "Sincronización cancelada",
      "No se han realizado cambios.",
      "info"
    );
  }
}

async function syncEmpleadosBuk() {
  //show a swal asking if the user wants to sync BUK employees data
  const swal = await import("sweetalert2");
  const result = await swal.default.fire({
    title: "Sincronizar Empleados BUK",
    text: "¿Está seguro de que desea sincronizar los empleados de BUK?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, sincronizar",
    cancelButtonText: "Cancelar",
  });

  if (result.isConfirmed) {
    await sincronizarEmpleadosBuk();
  } else {
    console.log(
      "Sincronización de empleados BUK cancelada",
      "No se han realizado cambios.",
      "info"
    );
  }
}
</script>
